import React from "react";
import { useNavigate } from "react-router-dom";
import "./CadastroHeader.css";
import { usePermissao } from "../../app/hooks/UsePermissao";
import { Button, Box, Typography } from '@mui/material';
import UserEmailDisplay from '../UserEmailDisplay/UserEmailDisplay';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export default function CadastroHeader({ title, subtitle, handle, backRoute, backTab }) {
  const navigate = useNavigate();
  const { temPermissao } = usePermissao();
 
  const handleBack = () => {
    if (backRoute) {
      navigate(backRoute, backTab ? { state: { activeTab: backTab } } : undefined);
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="cadastro-header">

      {/* TOPO */}
      <UserEmailDisplay />

      {/* HEADER */}
      <div className="header-row">

        <Button
          variant="text"
          onClick={handleBack}
          className="back-button"
          startIcon={<ArrowBackIcon />}
        >
          <span className="back-text">Voltar</span>
        </Button>

        {/* TÍTULO */}
        <div className="header-center">
          <h1>{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>

        {/* AÇÃO */}
        <div className="actions">
          {temPermissao("Cadastro.Criar") && <Button
            variant="contained"
            onClick={handle}
            sx={!handle ? { visibility: 'hidden' } : {}}
            disabled={!handle}
          >
            Cadastrar
          </Button> }
        </div>

      </div>

    </div>
  );
}